import { render } from "./PlayScreen.vue?vue&type=template&id=8a292f1e&scoped=true"
import script from "./PlayScreen.vue?vue&type=script&lang=js"
export * from "./PlayScreen.vue?vue&type=script&lang=js"

import "./PlayScreen.vue?vue&type=style&index=0&id=8a292f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a292f1e"]])

export default __exports__